import { Link } from 'react-router-dom';

export default function AboutTeaser() {
  return (
    <section className="bg-[#111111] py-20 px-6 md:px-12 overflow-hidden">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
        {/* Image */}
        <div className="relative">
          <div className="w-full h-0 pb-[120%] relative overflow-hidden">
            <img
              src="https://storage.readdy-site.link/project_files/9eec93be-30e4-4db4-94c1-4bae9d306ad9/5f8916d8-3059-4813-a602-63693a78db97_DSC06132.jpg?v=1f4f050b810828d02264846885c71bb1"
              alt="Dirty Birdy"
              className="absolute inset-0 w-full h-full object-cover object-top"
            />
          </div>
          {/* Accent border */}
          <div className="absolute -bottom-4 -right-4 w-full h-full border-2 border-brand-yellow pointer-events-none" />
          {/* IE badge */}
          <div className="absolute top-6 -right-4 bg-brand-yellow px-4 py-2">
            <span className="font-display text-black text-sm tracking-widest">909 LEGEND</span>
          </div>
        </div>

        {/* Text */}
        <div className="flex flex-col gap-6">
          <p className="font-heading font-light text-brand-orange tracking-[0.3em] uppercase text-xs">
            The Artist
          </p>
          <h2 className="font-display text-5xl md:text-6xl text-white leading-tight tracking-wide">
            FROM THE <span className="text-brand-yellow">INLAND EMPIRE</span>
          </h2>
          <div className="w-16 h-1 bg-brand-orange" />
          <p className="font-body text-white/60 text-base leading-relaxed">
            Dirty Birdy didn&apos;t just come from the Inland Empire — he was forged by it. Rising from the streets of San Bernardino, he crafted a style that&apos;s unmistakably West Coast yet entirely his own. His lyrics go places other rappers are afraid to go, and his delivery? Pure mastery.
          </p>
          <p className="font-body text-white/60 text-base leading-relaxed">
            From underground cyphers to headlining stages, Dirty Birdy has earned every stripe. His mic skills are praised across California and beyond. A true legend in the making — already made.
          </p>
          <Link
            to="/about"
            className="whitespace-nowrap self-start font-heading font-semibold text-sm tracking-widest uppercase bg-brand-yellow text-black px-8 py-3 hover:bg-brand-orange hover:text-white transition-colors duration-200 cursor-pointer"
          >
            Full Story
          </Link>
        </div>
      </div>
    </section>
  );
}
